var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearning1 = function SvgLearning1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M23.82 12.089V8.725A7.614 7.614 0 0 0 16 1.336a7.614 7.614 0 0 0-7.82 7.389v3.364M16 30.667 4.558 26.77a1.67 1.67 0 0 1-1.267-1.564v-8.54a1.81 1.81 0 0 1 2.4-1.564L16 18.675m0 11.992V18.675m0 11.992 11.442-3.897a1.67 1.67 0 0 0 1.267-1.557V16.67a1.81 1.81 0 0 0-2.4-1.564L16 18.675m4.888 2.216 2.933-.978m-12.71-9.776a4.888 4.888 0 1 0 9.777 0 4.888 4.888 0 0 0-9.776 0",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgLearning1;